<p-dialog
  [(visible)]="isVisible"
  [modal]="true"
  [closable]="false"
  [dismissableMask]="true"
  [style]="{ width: '486px' }"
  [attr.aria-label]="modalData()?.title || 'Confirmación'"
  contentStyleClass="rounded-2xl !p-0 overflow-hidden"
  [focusOnShow]="false"
>
  <!-- Contenido -->
  @if (modalData()) {
  <div class="px-4 pt-6">
    <div class="space-y-1.5">
      <!-- Fila icono + texto -->
      <div class="flex items-center gap-5">
        <img
          [src]="'assets/icons/' + iconSrc()"
          alt="icon"
          class="h-5 w-5 flex-shrink-0"
          aria-hidden="true"
        />
        <div class="flex flex-col">
          <p class="qbrain-text-base qbrain-text-primary font-bold"> {{modalData()?.title}} </p>
          <p
            class="qbrain-text-primary leading-6 py-0.5 pt-2"
            [innerHTML]="modalData().message"
          ></p>
        </div>
      </div>
    </div>
  </div>
  }

  <ng-template pTemplate="footer">
    @if (modalData()) {
    <div class="px-3 pt-3">
      <div class="flex">
        <!-- 10px -->
        <p-button
          [label]="confirmLabel()"
          severity="primary"
          styleClass="no-wrap-button"
          (onClick)="confirmAction()"
        >
        </p-button>
      </div>
    </div>

    }
  </ng-template>
</p-dialog>
